<section class="methodology-section axs-flex-inner-wrapper">
  <div class="axs-lg-offset-left-1 axs-lg-offset-right-1">
    <div class="methodology-section__content">
      <h2 class="methodology-section__title text-title-1 weight-bold margin-bottom-5">
        {{ methodologyContent?.methodology }}
      </h2>

      <div class="methodology-section__card">
        <h3 class="methodology-section__subheading text-subtitle-1 weight-bold">
          {{ methodologyContent?.methodologySubheading }}
        </h3>

        <p class="methodology-section__paragraph text-body-1">
          {{ methodologyContent?.methodologyDesc }}
        </p>

        <p class="methodology-section__paragraph text-body-1">
          <strong>{{ methodologyContent?.taxesPaidWithCashHeader }}</strong>
          {{ methodologyContent?.taxesPaidWithCash }}
        </p>

        <p class="methodology-section__paragraph text-body-1">
          <strong>{{ methodologyContent?.paidFromEfficientTaxableAccountHeader }}</strong>
          {{ methodologyContent?.paidFromEfficientTaxableAccount }}
        </p>

        <p class="methodology-section__paragraph text-body-1">
          <strong>{{ methodologyContent?.paidFromInefficientTaxableAccountHeader }}</strong>
          {{ methodologyContent?.paidFromInefficientTaxableAccount }}
        </p>

        <p class="methodology-section__paragraph text-body-1">
          <strong>{{ methodologyContent?.taxesFromIraHeader }}</strong>
          {{ methodologyContent?.iraDescOne }}
        </p>

        <p class="methodology-section__paragraph text-body-1">
          {{ methodologyContent?.iraDescTwo }}
        </p>

        <p class="methodology-section__paragraph text-body-1">
          {{ methodologyContent?.iraDescThree }}
        </p>

        <p class="methodology-section__paragraph text-body-1">
          {{ methodologyContent?.iraDescFour }}
        </p>

        <p class="methodology-section__paragraph text-body-1 methodology-section__paragraph--last">
          {{ methodologyContent?.iraDescFive }}
        </p>

        <ngx-axs-button
          axsType="primary"
          axsTheme="black"
          axsSize="medium"
          [axsShowIcon]="true"
          axsIconType="download"
          [axsText]="methodologyContent?.downloadTheFullResearchPaper || ''"
          [axsLink]="researchPaperLink"
          [axsOpenInNewTab]="true"
          (axsClick)="adobeTaggingPDFDownloadEvent('ISGBETR:download full research paper under methodogy body2')"
        ></ngx-axs-button>
      </div>
    </div>
  </div>
</section>